// 'use client'
// import { useEffect } from "react";
// import AOS from "aos"
// import 'aos/dist/aos.css';

// const Aoscompo = ({children}:any) => {
//     useEffect(() => {
//         AOS.init({
//             duration: 800,
//             once: false,
//         })
//     }, [])
//   return (
//     <div>
//       {children}
//     </div>
//   )
// }

// export default Aoscompo


"use client";

import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Aoscompo() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
    });
  }, []);

  return null;
}

